// Mapeamento de colunas do "Importar dados" unificado (spec 146).
// `columns` vem do servidor: [{ key, entity, label, header, required, custom }].

/**
 * Sugere o campo de cada coluna do arquivo só quando o nome é IDÊNTICO ao cabeçalho do campo
 * (ex.: "Contato: Email"), como no Synco. É o que faz o arquivo exportado e a planilha de exemplo
 * mapearem sozinhos; qualquer outro nome fica sem campo para o usuário escolher.
 * Um campo nunca é sugerido para duas colunas.
 */
export const suggestMapping = (fileHeaders, columns) => {
  const exact = new Map(columns.map(column => [column.header, column.key]));
  const used = new Set();

  return fileHeaders.reduce((mapping, header) => {
    const key = exact.get(header);
    const available = key && !used.has(key);
    if (available) used.add(key);
    return { ...mapping, [header]: available ? key : '' };
  }, {});
};

const mappedKeys = mapping => Object.values(mapping).filter(Boolean);

/** Campos escolhidos em mais de uma coluna (bloqueiam a importação). */
export const duplicatedKeys = mapping => {
  const counts = mappedKeys(mapping).reduce(
    (result, key) => ({ ...result, [key]: (result[key] || 0) + 1 }),
    {}
  );
  return Object.keys(counts).filter(key => counts[key] > 1);
};

/**
 * Campos obrigatórios que faltam para o que o arquivo parece conter (aviso, não bloqueia):
 * negociação exige título, pipeline e um contato; contato e empresa exigem o nome.
 */
export const missingRequiredColumns = (mapping, columns) => {
  const keys = new Set(mappedKeys(mapping));
  const entitiesInUse = new Set(
    columns.filter(column => keys.has(column.key)).map(column => column.entity)
  );
  if (keys.has('deal.title')) entitiesInUse.add('contact');
  return columns.filter(
    column =>
      column.required &&
      entitiesInUse.has(column.entity) &&
      !keys.has(column.key)
  );
};

export const hasMappedColumn = mapping => mappedKeys(mapping).length > 0;

/** Só as colunas mapeadas vão para o servidor. */
export const buildMappingPayload = mapping =>
  Object.fromEntries(Object.entries(mapping).filter(([, key]) => key));
